import React from 'react';
import PropTypes from 'prop-types';

import { TableRow, TableCell, Button } from '@mui/material';
import { Link } from 'react-router-dom';

const ListItem = props => {
  const { mission } = props;
  const { id, status, createDate, originOrderId } = mission;

  return (
    <TableRow>
      <TableCell>{status}</TableCell>
      <TableCell>
        <Button component={Link} to={`/mission/${id}`}>
          {id}
        </Button>
      </TableCell>
      <TableCell>
        {new Date(createDate)
          .toISOString()
          .slice(0, 19)
          .replace('T', ' ')}
      </TableCell>
      <TableCell>
        <Button component={Link} to={`/order/${originOrderId}`}>
          Order: {originOrderId}
        </Button>
      </TableCell>
    </TableRow>
  );
};

ListItem.propTypes = {
  mission: PropTypes.shape({
    id: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    createDate: PropTypes.number.isRequired,
    originOrderId: PropTypes.string.isRequired
  }).isRequired
};

ListItem.defaultProps = {};

export default ListItem;
